import { render, staticRenderFns } from "./UserQuiz.vue?vue&type=template&id=1aa2e164&"
import script from "./UserQuiz.vue?vue&type=script&lang=js&"
export * from "./UserQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports